// import

import {styled} from 'goober';

import {ZigZag} from 'modules/Svg';

import {AppFooterLegal} from './AppFooterLegal';
import {AppFooterSignup} from './AppFooterSignup';

// component

export function AppFooter() {
  return (
    <Footer data-test="app-footer">
      <ZigZag className="zig" color="blue" id="footer" />

      <div className="content">
        <div className="inner">
          <AppFooterSignup />
        </div>

        <div className="rule" />

        <div className="inner">
          <AppFooterLegal />
        </div>
      </div>
    </Footer>
  );
}

// styles

const Footer = styled('footer')`
  position: relative;
  z-index: 1;

  .content {
    position: relative;
    padding: 6rem 3rem;
    color: var(--white);
    background-color: var(--blue);

    &::before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: -0.125rem;
      height: 0.125rem;
      background-color: var(--blue);
      z-index: -1;
    }
  }

  .inner {
    margin: 0 auto;
    max-width: var(--bp-l);
  }

  .rule {
    margin: 3rem auto;
    width: 75%;
    height: var(--rpx);
    background:
      linear-gradient(
        90deg,
        rgba(var(--rgb-blue), 0),
        var(--blue-70),
        var(--blue-70),
        rgba(var(--rgb-blue), 0)
      );
  }
`;
